import { z } from "zod";
import { cbHttp } from "./http.service"
import { SettingsSchema } from "@/schemas/settings.schema";

export const getSettings = async (): Promise<z.infer<typeof SettingsSchema>[]> => {
    return cbHttp.get("/api/settings/settings");
}

export const updateSetting = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/settings/updatesetting", data);
}

export const createSetting = async(data: FormData): Promise<z.infer<typeof SettingsSchema>> => {
    return cbHttp.post("/api/settings/createsettings", data);
}